import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAttributeGroup } from 'src/app/assabil-kernel/models/entities/control-tables/product-attribute-group';


@Component({
  selector: 'app-product-attribute-group',
  templateUrl: './product-attribute-group.component.html',
  styleUrls: ['./product-attribute-group.component.scss']
})
export class ProductAttributeGroupComponent extends BasePage2<ProductAttributeGroup > {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  productAttributeGroups: ProductAttributeGroup[] = [];
  // ---------------------------------------------------
  
  //----------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName  = 'productAttributeGroup';
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------

  listFields = [
      { prop: 'productAttributeGroupCode', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },

  ]
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------

  getRows(): ProductAttributeGroup[] {
      return this.productAttributeGroups;
  }
  
  //----------------------------------------------------------------------

  
  //----------------------------------------------------------------------
    new(){
        let entity : ProductAttributeGroup = new ProductAttributeGroup();
        entity.inserted = true;
        entity.edit = true;
        this.productAttributeGroups.push(entity);
        this.productAttributeGroups = [...this.productAttributeGroups];
        }
   //----------------------------------------------------------------------

       
   //----------------------------------------------------------------------
  saveRow(row: ProductAttributeGroup): Promise<ProductAttributeGroup> {
      return null;
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------

  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.productAttributeGroups = result;
        
    }).catch(error => {
        this.showError(error);
    })
  }

  }
   //----------------------------------------------------------------------

